import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, Input, Label, Row } from "reactstrap";

type TProps = {
  form: any;
  type: "plan" | "subject";
};
export const FeatureComponent: React.FC<TProps> = ({ form, type }) => {
  const { t } = useTranslation();
  const [selectAll, setSelectAll] = useState<boolean>();

  useEffect(() => {
    let selectedCount = 0;
    Object.keys(form.values.feature).forEach((key) => {
      if (form.values.feature[key] === true) {
        selectedCount++;
      }
    });
    if (selectedCount === Object.keys(form.values.feature).length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [form.values]);

  const onChangeSelectAll = ({ target }: any) => {
    const { checked } = target;
    if (checked) {
      form.setValues({
        ...form.values,
        feature: {
          featureLectures: true,
          featureExams: true,
          featureSkills: true,
          featureFlashCards: true,
          featureNotes: true,
          featureAskTeacher: true,
          featureLiveLecture: true,
          featureNotesDelivery: true,
          featureFlashCardDelivery: true,
          featureStatistics: true,
          featureOlympic: true,
          featureAskAi: true,
        },
      });
    } else {
      form.setValues({
        ...form.values,
        feature: {
          featureLectures: false,
          featureExams: false,
          featureSkills: false,
          featureFlashCards: false,
          featureNotes: false,
          featureAskTeacher: false,
          featureLiveLecture: false,
          featureNotesDelivery: false,
          featureFlashCardDelivery: false,
          featureStatistics: false,
          featureOlympic: false,
          featureAskAi: false,
        },
      });
    }
  };

  return (
    <fieldset>
      <legend>{t("features")}</legend>
      <Row>
        <Col md={12}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="selectAll"
              checked={selectAll}
              value={(selectAll || false) as any}
              onChange={onChangeSelectAll}
            />
            <Label className="form-check-label" htmlFor="selectAll">
              {t("selectAll")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureLectures"
              checked={form.values.feature.featureLectures}
              value={(form.values.feature.featureLectures || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureLectures"
            >
              {t("enableLectures")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureExams"
              checked={form.values.feature.featureExams}
              value={(form.values.feature.featureExams || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label className="form-check-label" htmlFor="feature.featureExams">
              {t("enableExams")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureSkills"
              checked={form.values.feature.featureSkills}
              value={(form.values.feature.featureSkills || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label className="form-check-label" htmlFor="feature.featureSkills">
              {t("enableSkills")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureFlashCards"
              checked={form.values.feature.featureFlashCards}
              value={(form.values.feature.featureFlashCards || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureFlashCards"
            >
              {t("enableFlashCard")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureNotes"
              checked={form.values.feature.featureNotes}
              value={(form.values.feature.featureNotes || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label className="form-check-label" htmlFor="feature.featureNotes">
              {t("enableNotes")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureAskTeacher"
              checked={form.values.feature.featureAskTeacher}
              value={(form.values.feature.featureAskTeacher || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureAskTeacher"
            >
              {t("enableAskTeacher")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureLiveLecture"
              checked={form.values.feature.featureLiveLecture}
              value={(form.values.feature.featureLiveLecture || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureLiveLecture"
            >
              {t("enableLiveLecture")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureNotesDelivery"
              checked={form.values.feature.featureNotesDelivery}
              value={(form.values.feature.featureNotesDelivery || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureNotesDelivery"
            >
              {t("enableNotesDelivery")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureFlashCardDelivery"
              checked={form.values.feature.featureFlashCardDelivery}
              value={
                (form.values.feature.featureFlashCardDelivery || false) as any
              }
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureFlashCardDelivery"
            >
              {t("enableFlashCardDelivery")}
            </Label>
          </div>
        </Col>
        <Col md={6}>
          <div className="form-check mb-4 mt-2">
            <Input
              className="form-check-input"
              type="checkbox"
              id="feature.featureStatistics"
              checked={form.values.feature.featureStatistics}
              value={(form.values.feature.featureStatistics || false) as any}
              onChange={form.handleChange}
              onBlur={form.handleBlur}
            />
            <Label
              className="form-check-label"
              htmlFor="feature.featureStatistics"
            >
              {t("enableStatistics")}
            </Label>
          </div>
        </Col>
        {type === "plan" && (
          <Col md={6}>
            <div className="form-check mb-4 mt-2">
              <Input
                className="form-check-input"
                type="checkbox"
                id="feature.featureOlympic"
                checked={form.values.feature.featureOlympic}
                value={(form.values.feature.featureOlympic || false) as any}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
              />
              <Label
                className="form-check-label"
                htmlFor="feature.featureOlympic"
              >
                {t("enableOlympic")}
              </Label>
            </div>
          </Col>
        )}
        {type === "plan" && (
          <Col md={6}>
            <div className="form-check mb-4 mt-2">
              <Input
                className="form-check-input"
                type="checkbox"
                id="feature.featureAskAi"
                checked={form.values.feature.featureAskAi}
                value={(form.values.feature.featureAskAi || false) as any}
                onChange={form.handleChange}
                onBlur={form.handleBlur}
              />
              <Label
                className="form-check-label"
                htmlFor="feature.featureAskAi"
              >
                {t("enableAskAi")}
              </Label>
            </div>
          </Col>
        )}
      </Row>
    </fieldset>
  );
};
